// @flow

import React, { Component } from 'react';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';
import $ from 'jquery';

import MonitorHelp from './MonitorHelp.jsx';

import './css/Help.css';


type T_Video = {
  title: string,
  video: string
};



const VIDEOS : Array<T_Video> = [
  {title: 'Inicio de Sesión'    , video: 'inicio_sesion.webm'             },
  {title: 'Cambiar Contraseña'  , video: 'cambiar_contrasena.mp4'        },
  {title: 'Mapas'               , video: 'mapas.webm'                     },
  {title: 'Estadísticas'        , video: 'estadisticas.webm'              },
  {title: 'Informe'             , video: 'crear_informe_de_servicio.webm' },
  {title: 'Pestaña Cultivable'  , video: 'pestana_cultivable.webm'        },
  {title: 'Creación de MT'      , video: 'crear_mapa_tematico.webm'       },
  {title: 'Ver y Borrar MT'     , video: 'ver_y_borrar_mapa_tematico.webm'},
  {title: 'Herramienta MAV'     , video: 'herramienta_mav.webm'           },
  {title: 'Herramienta Medidas' , video: 'herramienta_medidas.webm'       },
  {title: 'Herramienta Visuales', video: 'herramienta_visuales.mp4'      },
  {title: 'Crear usuario'       , video: 'crear_coordinador.mp4'          }   // solo para perfiles con app.can_admin_users() === true
];



type T_HelpProps = {
  can_admin_users: boolean
};



export default class Help extends Component<T_HelpProps> {
  go_link: (ev: SyntheticInputEvent<*>) => void;
  
  
  constructor(props: T_HelpProps) {
    super(props);
    
    this.go_link = this.go_link.bind(this);
  }
  
  
  
  go_link(ev: SyntheticInputEvent<*>): void {
    const el = $(`#${ev.target.dataset.link}`).get(0);
    
    if (el) {
      if (el.scrollIntoViewIfNeeded && typeof el.scrollIntoViewIfNeeded === 'function') {
        el.scrollIntoViewIfNeeded();
      }
      else {
        scrollIntoViewIfNeeded(el);
      }
    }
  }
  
  
  
  get_videos(): Array<T_Video> {
    return VIDEOS.filter((pair) => {
      if (this.props.can_admin_users) {
        return true;
      }
      else {
        return pair.title.indexOf('usuario') === -1;
      }
    });
  }
  
  
  
  render() {
    const MY_VIDEOS = this.get_videos();
    
    return (
      <div className='div_help'>
        <div className='help_title'>
          <h1>Geodatabase</h1>
          
          <p>
            Bienvenido al Centro de Ayuda Geodatabase. Mediante breves videos, le presentamos
            las herramientas y funciones que podrá utilizar en cada módulo de esta plataforma.
          </p>
        </div>
        
        <div className='help_videos'>
          {MY_VIDEOS.map((pair, index) => {
            return (<MonitorHelp {...pair} key={index} last={index === MY_VIDEOS.length - 1} />);
          })}
        </div>
        
        <div className='help_links'>
          <ul id='doc-menu' className='nav doc-menu hidden-xs fix'>
            {MY_VIDEOS.map((pair, index) => {
              return (
                <li key={index}>
                  <a className='scrollto link-marg' data-link={`${pair.video.replace(/\./g, '_')}`} onClick={this.go_link}>
                    • {pair.title}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Help.jsx